<template>
  <div>
    <cargo-ag-grid
      v-show="innerVisible"
      config-module="2024032101"
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      class="lcl-dynamic-ag-grid"
    />
  </div>
</template>

<script>

import { getJyLclDynamicList } from '@/api/booking/jyWarehouse'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'JyLclDynamicDialog',
  props: {
    visible: { type: Boolean, default: false },
    callback: { type: Function, default: null },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      rowData: [],
      gridOptions: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          colId: 'containerNo',
          width: 100,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.Releasing'),
          field: 'releaseTime',
          colId: 'releaseTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.TakeContainerNotice'),
          field: 'noticeTakeContTime',
          colId: 'noticeTakeContTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.TakeContainerDone'),
          field: 'takeContTime',
          colId: 'takeContTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.PreloadContainerOrder'),
          field: 'sendContPreloadTime',
          colId: 'sendContPreloadTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.PreloadContainerDone'),
          field: 'contPreloadTime',
          colId: 'contPreloadTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.SendPort'),
          field: 'sendPortCarTime',
          colId: 'sendPortCarTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.SendPortStart'),
          field: 'carStartTime',
          colId: 'carStartTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('SeaExport.ArrivalPort'),
          field: 'arrivalTime',
          colId: 'arrivalTime',
          width: 125,
          tooltipValueGetter: (params) => params.value
        }
      ]
    }
  },
  computed: {

  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      const loading = getLoading4Cxt()
      this.rowData = []
      getJyLclDynamicList({ jobUuid: this.jobUuid }).then(res => {
        this.rowData = res.data
      }).catch(() => {
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>
.lcl-dynamic-ag-grid {
  width: 1100px;
  height: auto;
  position: fixed;
  bottom: 60px;
  right: 30px;
  display: flex;
}
</style>
